import { createSignal, For, Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { Grid } from '../../grid-system/grid/grid';
import { Section } from '../../grid-system/section/section';
import theme from '../../style/theme';
import { ErrorCatcher } from '../../tools/error-catcher';
import { Heading } from '../../ui-components/heading/heading';
import { AngleDownIcon } from '../icons-library/angle-down';
import {
    StyledPlaceHolderLatestArticlesBase,
    StyledPlaceHolderLatestArticlesListHorizontal,
    StyledShowMoreButton,
} from '../related-posts-list/related-posts-list.style';
import { VideoPostCard } from '../videos/video-post-card/video-post-card';
import { VideoData } from '../videos/videos-types';

type RelatedVideosProps = {
    heading: string;
    relatedVideos: VideoData[];
}

export const RelatedVideos = (props: RelatedVideosProps) => {
    const { localize } = useContext(AppContext);

    const [currentPage, setCurrentPage] = createSignal(1);
    const postsPerPage = 3;
    const maxPages = () => props.relatedVideos.length / postsPerPage;
    const isLastPage = () => currentPage() >= maxPages();

    const ShowMoreButton = (buttonProps: { orientation: 'vertical' | 'horizontal' }) => {
        return (
            <Show when={true}>
                <StyledShowMoreButton orientation={buttonProps.orientation} type="button" onClick={() => setCurrentPage(currentPage() + 1)}>
                    <div>{localize('show-more', 'show more')}</div>
                    <AngleDownIcon fill={theme.palette.red} {...{ height: 2.14, width: 2.86 }} />
                </StyledShowMoreButton>
            </Show>
        );
    };

    return (
        <ErrorCatcher componentName="Related videos">
            <Section widthType="bgFull" templateShorthand={[12]} customCss='margin-top: 5rem;'>
                <StyledPlaceHolderLatestArticlesBase>
                    <Heading tag={'h3'} variant={'medium'}>
                        {props.heading}
                    </Heading>
                    <StyledPlaceHolderLatestArticlesListHorizontal>
                        <Grid
                            templateShorthand={[4, 4, 4]}
                            responsive={{
                                tablet: [6, 6],
                                mobile: [12],
                            }}
                        >
                            {/* TODO: it is better if we use real pagination here.. with fetching just 3 elements at once with offset and limit... So the plan is to fix it later */}
                            <For each={props.relatedVideos.slice(0, currentPage() * postsPerPage)}>
                                {(video) => (
                                    <VideoPostCard
                                        title={video.video_title.trim()}
                                        videoUrl={video.video_link}
                                        inGrouping={true}
                                        isHealthcareProfessional={video.isHealthcareProfessional}
                                        permalink={video.permalink}
                                        image={video?.image}
                                        ableToPlay={false}
                                        isVisibleForPublic={video.isVisibleForPublic}
                                    />
                                )}
                            </For>
                        </Grid>
                        <Show when={!isLastPage()}>
                            <ShowMoreButton orientation="horizontal" />
                        </Show>
                    </StyledPlaceHolderLatestArticlesListHorizontal>
                </StyledPlaceHolderLatestArticlesBase>
            </Section>
        </ErrorCatcher>
    );
};
